export const dedupeById = <T extends { id?: string }>(items: T[] | null | undefined): T[] => {
  const map = new Map<string, T>()
  for (const item of items ?? []) {
    if (item?.id && !map.has(item.id)) {
      map.set(item.id, item)
    }
  }

  return Array.from(map.values())
}

export const indexById = <T extends { id?: string | null }>(
  items: T[] | null | undefined,
): Record<string, T> => {
  const entries = (items ?? [])
    .filter((item): item is T & { id: string } => Boolean(item?.id))
    .map((item) => [item.id, item] as const)

  return Object.fromEntries(entries)
}

export const buildContactOrderByEventId = ({
  events,
  contactOrders,
}: {
  events: ScheduleEvent[]
  contactOrders?: ContactOrder[] | null
}): Record<string, ContactOrder> => {
  const eventIdByContactOrderId = new Map<string, string>()
  events.forEach((event) => {
    if (event.contact_order_id) {
      eventIdByContactOrderId.set(event.contact_order_id, event.id)
    }
  })

  const contactOrderByEventId: Record<string, ContactOrder> = {}
  dedupeById(contactOrders ?? []).forEach((order) => {
    const targetEventId =
      order.schedule_event_id || (order.id ? eventIdByContactOrderId.get(order.id) : null)

    if (targetEventId && !contactOrderByEventId[targetEventId]) {
      contactOrderByEventId[targetEventId] = order
    }
  })

  return contactOrderByEventId
}
